import {on} from 'delegated-events'

function selectRepoItem(event: Event) {
  const item = event.target as HTMLInputElement
  const form = item.closest<HTMLElement>('.js-packages-repo-container')!.querySelector('.js-packages-repo-form')!
  const selectedRepoInput = createRepoInput(item)
  const existing = form.querySelector(`[id='repository-${selectedRepoInput.value}']`)
  if (existing) {
    existing.replaceWith(selectedRepoInput)
  } else {
    form.append(selectedRepoInput)
  }
}

function createRepoInput(item: HTMLInputElement): HTMLInputElement {
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = 'update_repo[repo_id]'
  input.value = item.value

  return input
}

on('change', '.js-packages-repo-container .js-repository-item-checkbox', selectRepoItem)
